import {IJobCountActionCreator,IJobCountActionTypes,IJobCountState} from 'models/IJobCountState';

const initialState:IJobCountState = {}

const reducer = (state = initialState, { type, payload }: IJobCountActionCreator) => {
    switch (type) {
      case IJobCountActionTypes.FETCH_JOB_COUNT_DETAILS_REQUEST:
        return {
          ...state,
          data:{},
        }
      case IJobCountActionTypes.FETCH_JOB_COUNT_DETAILS_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;